import { render, staticRenderFns } from "./ProfitAndLoss.vue?vue&type=template&id=3702375e&scoped=true&"
import script from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndLoss.vue?vue&type=style&index=0&id=3702375e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702375e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VIcon,VImg})
